/** @prettier */
import { connect } from 'react-redux';

import {
  clearMultipleSelections,
  reloadPreviousSelections,
  removeSelectionError,
  requestPermutations,
  requestTotalOdds,
  resetSelectedBonusId,
  resetSubmitMultipleError,
  resetTotalOdds,
  setInitialStake,
  setMultiplesBonusId,
  setPermutationType,
  setSelectionErrors,
  submitMultiple,
} from '@xanadu/ui-shared/modules/multiples/actions';
import { removeOffersByCids } from '@xanadu/ui-shared/modules/unsubmittedOffers/actions';

import BuildView from '../../../components/Multiples/BuildView';

const mapDispatchToProps = {
  clearMultipleSelections,
  removeOffersByCids,
  resetTotalOdds,
  submitMultiple,
  resetSubmitMultipleError,
  requestTotalOdds,
  requestPermutations,
  setPermutationType,
  reloadPreviousSelections,
  setMultiplesBonusId,
  setInitialStake,
  setSelectionErrors,
  removeSelectionError,
  resetSelectedBonusId,
};

const mapStateToProps = (state) => {
  const bonusBalance = state.getIn(['user', 'balance', 'bonusFreeFunds']); // subject to if not needed
  const freeBets = state.getIn(['promotions', 'manualBonus', 'data']);
  const bonusAllowed = bonusBalance >= 0.1;

  return {
    multipleBuild: state.getIn(['multiples', 'build']),
    selectionErrors: state.getIn(['multiples', 'selectionErrors']),
    previousMultipleBuild: state.getIn(['multiples', 'previousBuild']),
    buildLoading: state.getIn(['multiples', 'loading']),
    buildSubmitted: state.getIn(['multiples', 'submitted']),
    requestError: state.getIn(['multiples', 'requestError']),
    currency: state.getIn(['user', 'currency']),
    product: state.getIn(['application', 'product']),
    initialStake: state.getIn(['multiples', 'initialStake']),
    selectedBonusId: state.getIn(['multiples', 'selectedBonusId']),
    allEvents: state.get('event'),
    freeBets,
    bonusAllowed,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildView);
